<template>
  <b-form-group>
    <b-form-group>
      <b
        ><h3>Sucursal: {{ selectedLocation.name }}</h3></b
      >
    </b-form-group>
    <b-form-group>
      <b-table
        v-if="scheduleIterable"
        responsive
        striped
        hover
        :items="dayOfTheWeek"
        :fields="tableHeader"
      >
        <template #cell(haveSchedule)="data">
          <b-form-checkbox
            v-model="
              scheduleIterable.find(
                (item) => item.dayOfTheWeek === data.item.id
              ).hasSchedule
            "
          />
        </template>
        <template #cell(day)="data">
          {{ data.item.value }}
        </template>
        <template #cell(start)="data">
          <b-form-select
            :options="hourOptions"
            v-model="
              scheduleIterable.find(
                (item) => item.dayOfTheWeek === data.item.id
              ).initialTime
            "
          />
        </template>
        <template #cell(lunch)="data">
          <b-form-select
            :options="hourOptions"
            v-model="
              scheduleIterable.find(
                (item) => item.dayOfTheWeek === data.item.id
              ).lunchTime
            "
          />
        </template>
        <template #cell(end)="data">
          <b-form-select
            :options="hourOptions"
            v-model="
              scheduleIterable.find(
                (item) => item.dayOfTheWeek === data.item.id
              ).finalTime
            "
          />
        </template>
        <template #cell(capacity)="data">
          <b-form-group label="AM">
            <b-form-input
              number
              v-model="
                scheduleIterable.find(
                  (item) => item.dayOfTheWeek === data.item.id
                ).morningDisponibility
              "
            />
          </b-form-group>
          <b-form-group label="PM">
            <b-form-input
              number
              v-model="
                scheduleIterable.find(
                  (item) => item.dayOfTheWeek === data.item.id
                ).eveningDisponibility
              "
            />
          </b-form-group>
        </template>
      </b-table>
    </b-form-group>
  </b-form-group>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import {
  BCardBody,
  BFormSelect,
  BFormGroup,
  BTable,
  BFormCheckbox,
  BFormDatepicker,
  BFormInput,
  BButton,
} from 'bootstrap-vue'

import VueElementLoading from 'vue-element-loading'

export default {
  components: {
    BCardBody,
    BFormSelect,
    VueElementLoading,
    BFormGroup,
    BTable,
    BFormCheckbox,
    BFormDatepicker,
    BFormInput,
    BButton,
  },
  data() {
    return {
      schedules: null,
      scheduleIterable: null,
      dayOfTheWeek: [
        { id: 1, value: 'Lunes' },
        { id: 2, value: 'Martes' },
        { id: 3, value: 'Miércoles' },
        { id: 4, value: 'Jueves' },
        { id: 5, value: 'Viernes' },
        { id: 6, value: 'Sábado' },
        { id: 0, value: 'Domingo' },
      ],
      tableHeader: [
        {
          key: 'haveSchedule',
          label: 'Activa',
          sortable: false,
          thStyle: { width: '5%' },
        },
        {
          key: 'day',
          label: 'Día',
          sortable: false,
          thStyle: { width: '15%' },
        },
        {
          key: 'start',
          label: 'Inicio',
          sortable: false,
          thStyle: { width: '20%' },
        },
        {
          key: 'lunch',
          label: 'Almuerzo',
          sortable: false,
          thStyle: { width: '20%' },
        },
        {
          key: 'end',
          label: 'Cierre',
          sortable: false,
          thStyle: { width: '20%' },
        },
        {
          key: 'capacity',
          label: 'Capacidad',
          sortable: false,
          thStyle: { width: '20%' },
        }
      ],
      hourOptions: [
        { value: '07:00', text: '07:00' },
        { value: '08:00', text: '08:00' },
        { value: '09:00', text: '09:00' },
        { value: '10:00', text: '10:00' },
        { value: '11:00', text: '11:00' },
        { value: '12:00', text: '12:00' },
        { value: '13:00', text: '13:00' },
        { value: '14:00', text: '14:00' },
        { value: '15:00', text: '15:00' },
        { value: '16:00', text: '16:00' },
        { value: '17:00', text: '17:00' },
        { value: '18:00', text: '18:00' },
        { value: '19:00', text: '19:00' },
        { value: '20:00', text: '20:00' },
        { value: '21:00', text: '21:00' },
      ],
    }
  },
  watch: {
    scheduleIterable: {
      handler(newValue){
        this.checkValidations()
        this.setScheduleForm(newValue)
      },
      deep: true
    }
  },
  computed: {
    ...mapState('locations', ['leads', 'selectedLocation'])
  },
  methods: {
    ...mapMutations('locations', ['toggleValidation','setScheduleForm']),
    ...mapActions('locations', ['getLocationById']),
    checkValidations() {
      let validation = false
      console.log(this.scheduleIterable)
      this.scheduleIterable.forEach((item) => {
        if (item.hasSchedule) {
          if (
            !item.initialTime ||
            !item.lunchTime ||
            !item.finalTime ||
            item.morningDisponibility === "" ||
            item.eveningDisponibility === ""
          ) {
            validation = true
          }
        }
      })
      this.toggleValidation(validation)
    },
    prepareData() {
      this.scheduleIterable = this.dayOfTheWeek.map((day) => {
        const dayFound = this.selectedLocation.schedules.find(
          (item) => item.dayOfTheWeek.number === day.id
        )
        if (dayFound) {
          return {
            id: dayFound.id,
            hasSchedule: true,
            wasAdded: false,
            dayOfTheWeek: day.id,
            initialTime: dayFound.initialTime,
            lunchTime: dayFound.lunchTime,
            finalTime: dayFound.finalTime,
            morningDisponibility: parseInt(dayFound.morningDisponibility),
            eveningDisponibility: parseInt(dayFound.eveningDisponibility),
          }
        } else {
          return {
            id: null,
            hasSchedule: false,
            wasAdded: true,
            dayOfTheWeek: day.id,
            initialTime: this.hourOptions[0].id,
            lunchTime: this.hourOptions[0].id,
            finalTime: this.hourOptions[0].id,
            morningDisponibility: 0,
            eveningDisponibility: 0,
          }
        }
      })
    },
  },
  created() {
    //this.setSelectedStatus(this.selectedLocation.lead_status)
    this.getLocationById().finally(result => {
      this.prepareData()
    })
    //this.schedules = this.selectedLocation.schedules
  },
}
</script>
